import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

import { fetchHomepageIfNeeded } from '../../actions'
import Profile from '../../classes/profile'
import Spinner from '../../components/Spinner'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'

class GroupAudienceAcquisitionContainer extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    homepage: PropTypes.object,
    fetchHomepage: PropTypes.func.isRequired
  }

  componentDidMount () {
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (homepage) {
      const networkId = homepage.details.network_entities.filter(e => e.is_default)
      const networkEntityId = networkId.length > 0 && networkId[0].audience_acquisition_entity_id
      if (networkEntityId) {
        this.setState({redirectTo: `/insights/acquisition/${networkEntityId}/rolling`})
      }
      else {
        this.setState({redirectTo: '/insights/library'})
      }
    } else {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.homepage !== this.props.homepage) {
      if (!this.props.homepage.isFetching) {
        if (this.props.homepage.details && this.props.homepage.details.network_entities && this.props.homepage.details.network_entities.length > 0) {
          const networkId = this.props.homepage.details.network_entities.filter(e => e.is_default)
          const networkEntityId = networkId.length > 0 && networkId[0].audience_acquisition_entity_id
          if (networkEntityId) {
            this.setState({redirectTo: `/insights/acquisition/${networkEntityId}/rolling`})
          }
        } else {
          this.setState({redirectTo: '/insights/library'})
        }
      }
    }
  }

  render () {
    if (this.state && this.state.redirectTo) {
      return (<Redirect to={this.state.redirectTo} />)
    } else {
      return (<Spinner />)
    }
  }
}

const mapStateToProps = () => {
  return (state) => {
    const profile = state.user.profile && new Profile(state.user.profile)
    const homepage = state.homepage.list
    const isAdmin = state.user.isAdmin
    return {
      isAdmin,
      profile,
      homepage
    }
  }
}

function mapDispatchToProps () {
  return (dispatch) => {
    return {
      fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupAudienceAcquisitionContainer)
